import styled, { css } from 'styled-components';
import { breakpoint } from '../../components/theme/breakpoint';
import { ContentWithSideBar } from '../../components/styled/containers';
import SearchBox from '../../components/search-box';

export const StyledContentWithSideBar = styled(ContentWithSideBar)`
  margin-top: 0;

  ${breakpoint.desktop`
    margin-top: ${({ theme }) => theme.spacing.medium};
  `};
`;
export const StyledH1 = styled.h1`
  margin-top: 0;
`;

export const StyledSearchBox = styled(SearchBox)`
  margin-top: ${({ theme }) => theme.spacing.medium};
`;
